import React from 'react';
import PropTypes from 'prop-types';
import {
  ClickConfirmationButton, ClickConfirmationContainer, ClickRedoButton, Ball,
} from './styles';

const ClickConfirmationPrompt = (props) => {
  const {
    x, y, imageSizeX, imageSizeY, onCancel, onGoToNextPage,
  } = props;

  // render this component on the x, y coordinates
  return (
    <>
      <Ball x={x} y={y} imageSizeX={imageSizeX} imageSizeY={imageSizeY} />
      <ClickConfirmationContainer x={x} y={y} imageSizeX={imageSizeX} imageSizeY={imageSizeY}>
        <ClickConfirmationButton
          aria-label="confirmButton"
          id="confirmButton"
          type="button"
          onClick={() => onGoToNextPage()}
        >
          Confirm my click
        </ClickConfirmationButton>
        <ClickRedoButton
          aria-label="cancelButton"
          id="cancelButton"
          type="button"
          onClick={onCancel}
        >
          Redo
        </ClickRedoButton>
      </ClickConfirmationContainer>
    </>
  );
};

ClickConfirmationPrompt.defaultProps = {
  onGoToNextPage: () => {},
};

ClickConfirmationPrompt.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  imageSizeX: PropTypes.number.isRequired,
  imageSizeY: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
  onGoToNextPage: PropTypes.func,
};

export default ClickConfirmationPrompt;
